module.exports = __webpack_public_path__ + "img/index5.38eccde6.png";